import React, { useMemo } from 'react';
import { useBooking } from '../../hooks/useBooking';
import { useSiteColors } from '../../hooks/useSiteColors';
import {
  normalizeListingSocials,
  sortListingSocials,
} from '../../utils/socials';

export function SiteFooter() {
  const { businessListing, reviews, locations } = useBooking();
  const c = useSiteColors();

  const galleryImages = businessListing?.cover_images ?? [];

  const aboutSocialEntries = useMemo(() => {
    const list = normalizeListingSocials(businessListing?.socials);
    if (!list?.length) return [];
    return sortListingSocials(list).filter(Boolean);
  }, [businessListing?.socials]);

  const showAboutSection =
    Boolean(businessListing?.about?.trim()) ||
    galleryImages.length > 0 ||
    aboutSocialEntries.length > 0;
  const hasReviews = reviews.length > 0;
  const hasLocationData =
    locations.length > 0 ||
    Boolean(businessListing?.address?.trim()) ||
    Boolean(businessListing?.google_place_id?.trim());

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (!businessListing) return null;

  return (
    <footer className="py-12" style={{ borderTop: `1px solid ${c.border}` }}>
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            {businessListing.logo_url && (
              <img src={businessListing.logo_url} alt="" className="h-6 object-contain" />
            )}
            <span className="text-lg font-bold" style={{ color: c.text }}>
              {businessListing.business_name}
            </span>
          </div>

          <div className="flex gap-7">
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-medium transition-colors hover:opacity-80"
              style={{ color: c.mutedText }}
            >
              Services
            </button>
            {showAboutSection && (
              <button
                onClick={() => scrollToSection('about')}
                className="text-sm font-medium transition-colors hover:opacity-80"
                style={{ color: c.mutedText }}
              >
                About
              </button>
            )}
            {hasReviews && (
              <button
                onClick={() => scrollToSection('reviews')}
                className="text-sm font-medium transition-colors hover:opacity-80"
                style={{ color: c.mutedText }}
              >
                Reviews
              </button>
            )}
            {hasLocationData && (
              <button
                onClick={() => scrollToSection('locations')}
                className="text-sm font-medium transition-colors hover:opacity-80"
                style={{ color: c.mutedText }}
              >
                Locations
              </button>
            )}
            <button
              onClick={() => scrollToSection('location')}
              className="text-sm font-medium transition-colors hover:opacity-80"
              style={{ color: c.mutedText }}
            >
              Contact
            </button>
          </div>
        </div>

        <div
          className="text-center mt-8 pt-6 text-xs"
          style={{ borderTop: `1px solid ${c.border}`, color: c.mutedText }}
        >
          &copy; {new Date().getFullYear()} {businessListing.business_name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
